import { pagePaths } from './config';

const api = {
  getRequestCreationPath: () => pagePaths['Create'],
};

export default api;

export type ApiType = typeof api;
